import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Protects routes that require admin role.
 * Redirects unauthenticated users to /login.
 * Redirects authenticated non-admins to /dashboard.
 */
const AdminRoute = () => {
  const { isAuthenticated, loading, isPlatformAdmin, isSuperAdmin, defaultHomeRoute } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#f8f9fa' }}>
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-4 border-t-transparent rounded-full animate-spin" style={{ borderColor: '#6366f1', borderTopColor: 'transparent' }} />
          <span className="text-slate-500 text-sm">Verifying access…</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!(isPlatformAdmin || isSuperAdmin)) {
    return <Navigate to={defaultHomeRoute || '/dashboard'} replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
